import { endOfDay, endOfMonth, format, formatDistanceToNow, isSameMonth, isSameYear, isToday, isYesterday, startOfDay, startOfMonth } from 'date-fns'
import { id } from 'date-fns/locale'

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
const formatDate = (dt: string | number | Date, fmt: string = 'PP') => {
  return format(dt, fmt, { locale: id })
}
export default {
  /**
   * Format date with given string format. Set locale to id
   * See https://date-fns.org/docs/format for accepted tokens
   */
  date: formatDate,

  dateLong: (dt: string | number | Date) => {
    return formatDate(dt, 'ccc, d MMM yyyy HH:mm')
  },

  /**
   * Shorter format date. If date is today, it will only show time,
   * otherwise show the date.
   */
  dateShort: (dt: string | number | Date) => {
    if (isToday(dt)) {
      return formatDate(dt, 'HH:mm')
    }
    if (isYesterday(dt)) {
      return 'Kemarin'
    }

    return formatDate(dt)
  },

  dateRelative: (dt: string | number | Date, addSuffix = true) => {
    return formatDistanceToNow(dt, { locale: id, addSuffix })
  },

  dateForm: (dt: string | number | Date) => {
    return formatDate(dt, 'yyyy-MM-dd')
  },

  formToday: () => formatDate(new Date(), 'yyyy-MM-dd'),

  dateRange: (dt1: string | number | Date, dt2: string | number | Date) => {
    if (isSameMonth(dt1, dt2)) {
      return formatDate(dt1, 'd') + ' - ' + formatDate(dt2, 'd MMMM yyyy')
    }
    if (isSameYear(dt1, dt2)) {
      return formatDate(dt1, 'd MMMM') + ' - ' + formatDate(dt2, 'd MMMM yyyy')
    }
    return formatDate(dt1, 'd MMMM yyyy') + ' - ' + formatDate(dt2, 'd MMMM yyyy')
  },
}

export type DateRangeMode = 'day' | 'month'

export const dateStart = (mode?: DateRangeMode) => {
  const params = new URLSearchParams(window.location.search)
  const dateStartParam = params.get('date_start')

  if (dateStartParam) {
    return new Date(dateStartParam)
  } else if (mode === 'month') {
    return startOfMonth(new Date())
  } else if (mode === 'day') {
    return startOfDay(new Date())
  }

  return null
}

export const dateEnd = (mode?: DateRangeMode) => {
  const params = new URLSearchParams(window.location.search)
  const dateEndParam = params.get('date_end')

  if (dateEndParam) {
    return new Date(dateEndParam)
  } else if (mode === 'month') {
    return endOfMonth(new Date())
  } else if (mode === 'day') {
    return endOfDay(new Date())
  }

  return null
}
